import React from "react";
import { Box, alpha } from "@mui/material";
import { progressGradient } from "@karda/design-tokens";
import { progressGradientAnimation } from "../animations";

export const ProgressBar: React.FC<{ progress: number }> = ({ progress }) => (
  <Box
    sx={{
      mt: 1.5,
      height: 6,
      borderRadius: 3,
      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        height: "100%",
        width: `${progress}%`,
        borderRadius: 3,
        background: (theme) =>
          progressGradient(theme.palette.primary.main, theme.palette.primary.light),
        backgroundSize: "200% 100%",
        animation: `${progressGradientAnimation} 2s ease infinite`,
        transition: "width 0.3s ease",
      }}
    />
  </Box>
);
